import Swal from "sweetalert2";

async function Relacionamento(laboratorio, otica) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };
  requestOptions["body"] = JSON.stringify({ cnpj: otica });

  const swalOptions = {
    icon: "warning",
    text: "Você não tem relacionamento com o laboratório informado no cupom.",
    width: "auto",
    title: "Aviso",
    confirmButtonColor: "#00518b",
    confirmButtonText: "Ok!",
  };

  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "get_account_labs.php", requestOptions);
    const data = await response.json();
    if (response.status === 200 && Array.isArray(data.laboratorios)) {
      const encontrado = data.laboratorios.some(lab => lab?.cnpj === laboratorio);
      if(!encontrado) Swal.fire(swalOptions);
      return encontrado;
    } else {
      await Swal.fire(swalOptions);
      return false;
    }
  } catch (error) {
    console.error("Erro na verificação de health:", error);
    await Swal.fire(swalOptions);
    return false;
  }
}

export { Relacionamento };
